<div class="current-station-location-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow">
            <mat-label>
                {{condition.type |
                translate:['tmc-yard.widgets.filter-administration.details-editor.transport.current-station-location-editor.location',
                translationService.language]}}
            </mat-label>
            <mat-select formControlName="location" name="location">

                <ng-container *ngFor="let location of locations">
                    <mat-option [value]="location">
                        {{location |
                        translate:["tmc-yard.widgets.filter-administration.details-editor.transport.current-station-location-editor.location."+location,
                        translationService.language]}}
                    </mat-option>
                </ng-container>

            </mat-select>
        </mat-form-field>
    </div>
</div>